<template>
    <div class="scene">
        <audio id="bgm" loop="loop" src="../static/bgm.mp3"></audio>
        <p :class="music ? 'music zhuan' : 'music'" @click="stopmusic"></p>
        <img src="../static/bg.png" draggable="false" oncontextmenu="return false;" class="bg" alt="">


        <img src="../static/p1.png" class="p1" alt="">
        <img src="../static/p1-1.png" class="p1-1" @click="tonews(1)" alt="">
        <img src="../static/p2.png" class="p2" v-show="p2" alt="">
        <img src="../static/p2-1.png" class="p2-1" v-show="p2" @click="tonews(2)"  alt="">
        <img src="../static/p3.png" class="p3" v-show="p3" alt="">
        <img src="../static/p3-1.png" class="p3-1" v-show="p3" @click="tonews(3)"  alt="">
        <img src="../static/p4.png" class="p4" v-show="p4" alt="">
        <img src="../static/p4-1.png" class="p4-1" v-show="p4" @click="tonews(4)" alt="">
        <img src="../static/p5.png" class="p5" v-show="p5" alt="">
        <img src="../static/p5-1.png" class="p5-1" v-show="p5" @click="tonews(5)"  alt="">
        <img src="../static/p6.png" class="p6" v-show="p6" alt="">
        <img src="../static/p6-1.png" class="p6-1" v-show="p6" @click="tonews(6)"  alt="">
        <img src="../static/p7.png" class="p7" v-show="p7" alt="">
        <img src="../static/p7-1.png" class="p7-1" v-show="p7" @click="tonews(7)"  alt="">
        <img src="../static/p8.png" class="p8" v-show="p8" alt="">
        <img src="../static/p8-1.png" class="p8-1" v-show="p8" @click="tonews(8)"  alt="">
        <img src="../static/p9.png" class="p9" v-show="p9" alt="">
        <img src="../static/p9-1.png" class="p9-1" v-show="p9" @click="tonews(9)"  alt="">
        <img src="../static/p10.png" class="p10" v-show="p10" alt="">
        <img src="../static/p10-1.png" class="p10-1" v-show="p10" @click="tonews(10)"  alt="">


        <img src="../static/endwords.png" class="endwords" v-show="p1" alt="">
    </div>
</template>

<script>
export default {
    data() {
        return {
            music: true,
            p1:false,
            p2:false,
            p3:false,
            p4:false,
            p5:false,
            p6:false,
            p7:false,
            p8:false,
            p9:false,
            p10:false,
        }
    },

    mounted() {
        window.addEventListener("scroll", this.scrolling)
        
        setTimeout(() => {
            let audio = document.getElementById("bgm");

            if (window.sessionStorage.getItem("music") == "false") {
                console.log(5431);
                this.music = false
                audio.pause();
            } else {


                if (window.sessionStorage.getItem("time") != "null") {

                    audio.currentTime = window.sessionStorage.getItem("time")
                    // audio.play()
                }

                audio.play()
    
            }
        }, 200);
    },
    methods: {
        jump(url) {
            var a = document.createElement("a");
            a.setAttribute("target", "_blank");
            a.setAttribute("href", url);

            a.click();
        },
        stopmusic() {
            let audio = document.getElementById("bgm");
            if (this.music == true) {
                this.music = false;
                audio.pause();
            } else {
                this.music = true;
                audio.volume = 0.5
                audio.play();
            }
        },
        scrolling() {

            // 滚动条距文档顶部的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            // 滚动条滚动的距离
            let scrollStep = scrollTop - this.oldScrollTop;
            // console.log("header 滚动距离 ", scrollTop);
            if (scrollTop > 0) {
                if (this.music) {
                    document.getElementById('bgm').volume = 0.5;
                    document.getElementById('bgm').play();
                }
            }
            // if (this.music == true) {
            //     document.getElementById("audio").play() 

            // }

            let bl = window.innerWidth / 375

            if (scrollTop > 100 * bl) {
                this.p2 = true
            } else {
                this.p2 = false
            }
            if (scrollTop > 600 * bl) {
                this.p3= true
            } else {
                this.p3 = false
            }
            if (scrollTop > 1000 * bl) {
                this.p4 = true
            } else {
                this.p4 = false
            }
            if (scrollTop > 1500 * bl) {
                this.p5= true
            } else {
                this.p5 = false
            }
            if (scrollTop > 2000 * bl) {
                this.p6 = true
            } else {
                this.p6 = false
            }
            if (scrollTop > 2500 * bl) {
                this.p7 = true
            } else {
                this.p7 = false
            }
            if (scrollTop > 2800 * bl) {
                this.p8 = true
            } else {
                this.p8 = false
            }

            if (scrollTop > 3200 * bl) {
                this.p9 = true
            } else {
                this.p9 = false
            }

            if (scrollTop > 3700 * bl) {
                this.p10 = true
            } else {
                this.p10 = false
            }

            if (scrollTop > 4100 * bl) {
                this.p1 = true
            } else {
                this.p1 = false
            }


       

            // 更新——滚动前，滚动条距文档顶部的距离
            this.oldScrollTop = scrollTop;

            //变量windowHeight是可视区的高度
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;

            //滚动条到底部的条件
            if (scrollTop + windowHeight == scrollHeight) {
                //你想做的事情
                console.log("header  你已经到底部了");
            }
            //   if (scrollStep < 0) {
            //     console.log("header 滚动条向上滚动了！");
            //   } else {
            //     console.log("header  滚动条向下滚动了！");
            //   }
            // 判断是否到了最顶部
            if (scrollTop <= 0) {
                console.log("header 到了最顶部")
            }
        },
        tonews(a) {
            console.log(333);
            
            let audio = document.getElementById("bgm");
            window.sessionStorage.setItem("time", audio.currentTime);
            window.sessionStorage.setItem("music", this.music);
            if (a == 1) {
                this.jump("https://share.jcy.jinhua.com.cn/c/240709/ARTyPhzkvCl6OKQXVE.html?id=1661985");
            } else if (a == 2) {
                this.jump('https://share.jcy.jinhua.com.cn/c/241010/ARTeDIqlYnODoHpxt8.html?id=1705214');
            } else if (a == 3) {
                this.jump('https://share.jcy.jinhua.com.cn/c/240531/ARTXbBJZ5m3W27uHNq.html?id=1629948');
            } else if (a == 4) {
                this.jump('https://share.jcy.jinhua.com.cn/c/241128/ARTNZk4zFGYjMO3srm.html?id=1723102');
            } else if (a == 5) {
                this.jump('https://share.jcy.jinhua.com.cn/c/240601/ART6hmo6Jo8Joaatco.html?id=1736729');
            } else if (a == 6) {
                this.jump('https://share.jcy.jinhua.com.cn/c/241204/ARTxIl7cwMeyLzFxko.html?id=1724991');
            } else if (a == 7) {
                this.jump('https://share.jcy.jinhua.com.cn/c/240203/ART25p0cca7zgTp9xZ.html?id=1735282');
            } else if (a == 8) {
                this.jump('https://share.jcy.jinhua.com.cn/c/240216/ARToHwcmJ79jOwLfTX.html?id=1735905');
            } else if (a == 9) {
                this.jump('https://share.jcy.jinhua.com.cn/c/241225/ARTOHAd2PFXj3DEq4i.html?id=1732244');
            } else if (a == 10) {
                this.jump('https://share.jcy.jinhua.com.cn/c/241228/ARTEJHssxITQYKTYIF.html?id=1732964');
            }
        },
    },
}
</script>

<style lang="less">
.scene {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    // height: 100vh;
    // overflow: hidden;
    // overflow-y: scroll;
    overflow-x: hidden;
    .bg {
        width: 100%;
        max-width: 100%;
        display: block;
    }

    .music {
        position: fixed;
        width: 50px;
        height: 50px;
        top: 35px;
        right: 20px;
        background: url("../static/music.png") center no-repeat;
        background-size: 100% 100%;
        z-index: 5;

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }


    .p1 {
        position: absolute;
        width: 300px;
        left: 0px;
        top: 120px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }

    }

    .p1-1 {
        position: absolute;
        width: 230px;
        right: 0px;
        top: 350px;
        animation: p11-ani 3s ease 1 forwards;

        @keyframes p11-ani {
            0% {
                right: -230px;
            }

            40% {
                right: -230px;
            }

            100% {
                right: 0px;

            }
        }

    }

    .p2 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 580px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }

    }

    .p2-1 {
        position: absolute;
        width: 270px;
        left: 5px;
        top: 755px;
        animation: p21-ani 3s ease 1 forwards;

        @keyframes p21-ani {
            0% {
                left: -270px;
            }

            40% {
                left: -270px;
            }

            100% {
                left: 5px;

            }
        }

    }

    .p3 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 980px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }

    }

    .p3-1 {
        position: absolute;
        width: 220px;
        right: 0;
        top: 1300px;
        animation: p31-ani 3s ease 1 forwards;

        @keyframes p31-ani {
            0% {
                right: -220px;
            }

            40% {
                right: -220px;
            }

            100% {
                right: 0px;

            }
        }

    }

    .p4 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 1380px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }

    }

    .p4-1 {
        position: absolute;
        width: 250px;
        left: 5px;
        top: 1820px;
        animation: p41-ani 3s ease 1 forwards;

        @keyframes p41-ani {
            0% {
                left: -270px;
            }

            40% {
                left: -270px;
            }

            100% {
                left: 5px;

            }
        }

    }

    .p5 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 1930px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }

    }

    .p5-1 {
        position: absolute;
        width: 320px;
        right: 5px;
        top: 2220px;
        animation: p51-ani 3s ease 1 forwards;

        @keyframes p51-ani {
            0% {
                right: -320px;
            }

            40% {
                right: -320px;
            }

            100% {
                right: 5px;

            }
        }

    }

    .p6 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 2400px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .p6-1 {
        position: absolute;
        width: 260px;
        left: 5px;
        top: 2720px;
        animation: p61-ani 3s ease 1 forwards;

        @keyframes p61-ani {
            0% {
                left: -260px;
            }

            40% {
                left: -260px;
            }

            100% {
                left: 5px;

            }
        }

    }

    .p7 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 2850px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .p7-1 {
        position: absolute;
        width: 260px;
        right: 5px;
        top: 3100px;
        animation: p11-ani 3s ease 1 forwards;

        @keyframes p11-ani {
            0% {
                right: -260px;
            }

            40% {
                right: -260px;
            }

            100% {
                right: 5px;

            }
        }

    }

    .p8 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 3150px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .p8-1 {
        position: absolute;
        width: 260px;
        left: 5px;
        top: 3500px;
        animation: p81-ani 3s ease 1 forwards;

        @keyframes p81-ani {
            0% {
                left: -270px;
            }

            40% {
                left: -270px;
            }

            100% {
                left: 5px;

            }
        }

    }

    .p9 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 3650px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .p9-1 {
        position: absolute;
        width: 280px;
        right: 5px;
        top: 4010px;
        animation: p11-ani 3s ease 1 forwards;

        @keyframes p11-ani {
            0% {
                right: -280px;
            }

            40% {
                right: -280px;
            }

            100% {
                right: 5px;

            }
        }

    }

    .p10 {
        position: absolute;
        width: 370px;
        left: 0px;
        top: 4180px;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .p10-1 {
        position: absolute;
        width: 240px;
        left: 5px;
        top: 4460px;
        animation: p101-ani 3s ease 1 forwards;

        @keyframes p101-ani {
            0% {
                left: -240px;
            }

            40% {
                left: -240px;
            }

            100% {
                left: 5px;

            }
        }

    }

    .endwords {
        position: absolute;
        width: 280px;
        top: 4620px;
        left: 50%;
        margin-left: -140px;
        animation: end-ani 2s ease 1 forwards;

        @keyframes end-ani {
            0% {
               opacity: 0;
            }

            100% {
             opacity: 1;

            }
        }
    }
}
</style>
